import React, { lazy, Suspense } from 'react';

// Redux
import { useSelector } from 'react-redux';

// Material
import Box from '@material-ui/core/Box';

// React Swipeable Views
import SwipeableViews from 'react-swipeable-views';

// Types
import { ApplicationState } from 'store';

// Material Theme
import { useTheme } from '@material-ui/core/styles';

// Components
import { TabPanel } from 'components/TabPanel';
import { CustomTabs } from 'components/ReportComponents';
import {
  PaymentInterface,
  TrasactionInterface,
} from 'store/ducks/employeesSales/types';
import { PaymentNavigation } from '../PaymentNavigation';
import { TransactionNavigation } from '../TransactionNavigation';
import { Order } from 'helpers/tableSortLabels';

const TotalCountComponent = lazy(() =>
  import('components/TotalCountComponent'),
);

interface StateProps {
  paymentGroupings: string[];
  transactionGroupings: any;
  setTableCSV: any;
  setTableReference: any;
  setCurrNavGuide: (param: number) => void;
  currNavGuide: number;
  paymentsList?: PaymentInterface[];
  transactionsList?: TrasactionInterface[];
  isPrinting?: boolean;
  isMounted?: 'initalState' | 'loading' | 'notLoading';
  setIsMounted?: (param: 'initalState' | 'loading' | 'notLoading') => void;
  setSimplePdfData?: (param: {
    title: string;
    subtitle: string;
    filters: string;
    headers: any;
    rows: any;
  }) => void;
  periodString?: string;
  paymentOrder?: string;
  paymentOrderBy?: string;
  setPaymentOrder?: (o: Order) => void;
  setPaymentOrderBy?: (o: string) => void;
  transactionOrder?: string;
  transactionOrderBy?: string;
  setTransactionOrder?: (o: Order) => void;
  setTransactionOrderBy?: (o: string) => void;
}

type Props = StateProps;

const TableNavagation: React.FC<Props> = ({
  paymentGroupings,
  transactionGroupings,
  setTableCSV,
  setTableReference,
  setCurrNavGuide,
  currNavGuide,
  paymentsList,
  transactionsList,
  isPrinting,
  isMounted,
  setIsMounted,
  setSimplePdfData,
  periodString,
  paymentOrder,
  paymentOrderBy,
  setPaymentOrder,
  setPaymentOrderBy,
  transactionOrder,
  transactionOrderBy,
  setTransactionOrder,
  setTransactionOrderBy,
}) => {
  const theme = useTheme();

  const initialPaymentsList = useSelector(
    (state: ApplicationState) => state.employeesSales.paymentsList,
  );

  const initialTransactionsList = useSelector(
    (state: ApplicationState) => state.employeesSales.transactionsList,
  );

  return (
    <>
      <Box>
        {currNavGuide === 0 && initialPaymentsList?.length! > 0 && (
          <Box width='100%' display='flex' justifyContent='flex-end'>
            <Suspense fallback='Carregando...'>
              <TotalCountComponent
                count={initialPaymentsList?.length! || 0}
                title='repasses'
                position='right'
              />
            </Suspense>
          </Box>
        )}

        {currNavGuide === 1 && initialTransactionsList?.length! > 0 && (
          <Box width='100%' display='flex' justifyContent='flex-end'>
            <Suspense fallback='Carregando...'>
              <TotalCountComponent
                count={initialTransactionsList?.length! || 0}
                title='transações'
                position='right'
              />
            </Suspense>
          </Box>
        )}

        <CustomTabs
          setCurrNavGuide={setCurrNavGuide}
          currNavGuide={currNavGuide}
          labels={['Repasses', 'Transações']}
        />
      </Box>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={currNavGuide}>
        {/* Repasses */}
        <TabPanel index={0} value={currNavGuide}>
          <PaymentNavigation
            groupings={paymentGroupings}
            setTableCSV={setTableCSV}
            setTableReference={setTableReference}
            paymentsList={paymentsList}
            setPaymentOrder={setPaymentOrder}
            setPaymentOrderBy={setPaymentOrderBy}
          />
        </TabPanel>
        {/* Transações */}
        <TabPanel
          index={1}
          value={currNavGuide}
          boxStyles={{ overflowY: 'hidden' }}>
          <TransactionNavigation
            groupings={transactionGroupings}
            setTableCSV={setTableCSV}
            setTableReference={setTableReference}
            transactionsList={transactionsList}
            isPrinting={isPrinting}
            isMounted={isMounted}
            setIsMounted={setIsMounted}
            setSimplePdfData={setSimplePdfData}
            periodString={periodString}
            setTransactionOrder={setTransactionOrder}
            setTransactionOrderBy={setTransactionOrderBy}
          />
        </TabPanel>
      </SwipeableViews>
    </>
  );
};

export { TableNavagation };
export default TableNavagation;
